import { Component, OnInit } from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { IMember } from 'app/shared/Domains/member';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { IAttendance } from 'app/shared/Domains/attendance';
import { AuthService } from 'common/services/auth.service';
import { LanguageService } from 'app/LanguageService/Language.Service';
import moment from 'moment-timezone';
@Component({
  selector: 'app-attendance-view',
  templateUrl: './attendance-view.component.html',
  host: { "(window:keyup)": "hotkeys($event)" },
  styleUrls: ['./attendance-view.component.css']
})
export class AttendanceViewComponent implements OnInit {
  scheduleOptions: any;
  member: IMember;
  memberdetails:any = [];
  events: any[];
  memberID: any;
  sourceTrainers: any[];
  trainingAttendanceDialog: boolean = false;
  users: any[];
  company: any;
  branch: any;
  selectedCalenderDate: any;
  selectedUser: any;
  role: any;
  user: any;
  filteredUsers: any[];
  flag: boolean=false;

  constructor(private languageService: LanguageService, private route: ActivatedRoute, private navRoute: Router, private confirmationService: ConfirmationService, private messageService: MessageService, private breadcrumbService: BreadcrumbService, private appServiceManager: AppServiceManager) {
    route.params.subscribe(
      params => {
        this.memberID = params['id'];
        if (this.memberID !== null && this.memberID !== undefined) {
          this.getmemberbyID();
        } else {
          navRoute.navigateByUrl('dashboard');
        }
      }
    );
  }

  setLabel(label) {
    return this.languageService.GetCurrentLanguage("AttendanceViewComponent", label);
  }

  ngOnInit() {
    this.member = new IMember();
    this.events = [];
    var date = new Date();
    this.company = AuthService.getLoggedInCompany();
    this.branch = AuthService.getLoggedInBranch();
    this.role = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    this.hideModal();
    this.scheduleOptions = {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      defaultDate: date.toLocaleDateString(),
      header: {
          left: "prev,next, today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
      },
      dateClick: (e) => {
        this.selectedCalenderDate = e.date;
          this.showDialog();
      },
  };
    this.getCustomerAttendanceByID();
  }

  showDialog() {
    this.trainingAttendanceDialog = true;
    this.hideModal();
}
hideModal() {
  if(this.flag==false)
    this.selectedUser = null;
}
  getmemberbyID() {
    this.appServiceManager.get("customers/" + this.memberID).subscribe((res: any) => {
      if (res) {
        this.member = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  getCustomerAttendanceByID() {
    this.appServiceManager.get("customers/attendanceLog/" + this.memberID).subscribe((res: any) => {
      if (res) {
        let attendance = [];
        for (let i = 0; i < res.response.length; i++) {
          let date = new Date(res.response[i].punch_time);
          let isoDate = date.toISOString();
          let attendance1 = {
            start : date.toISOString(),
            end : date.toISOString(),
            title: "Attendance",
          }
          attendance[i] = attendance1
        }
        this.events = attendance;
        this.breadcrumbService.setItems([
          { label: 'Member Attendance Management' },
          { label: 'All Members', routerLink: '/attendance' },
          { label: this.member.name}
        ]);
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  markAttendance() {
    this.confirmationService.confirm({
      message: "Are you sure you want to update member attendance?",
      accept: () => {
        this.user = JSON.parse(localStorage.getItem('currentUser'));
        const pakistanTime = moment().tz('Asia/Karachi').format('YYYY-MM-DD HH:mm:ss');
        console.log("pakistanTime",pakistanTime);
        let formattedDate = moment().tz('Asia/Karachi').format('YYYY-MM-DD HH:mm:ss');
        this.memberdetails = {
          company: this.member.company,
          branch: this.member.branch,
          customerId: this.member._id,
          tagNumber: this.member.tagNumber,
          punch_time: formattedDate,
          enteredBy: this.user.name,
        };
        this.appServiceManager.post("customers/attendanceLogByCustomerID", this.memberdetails).subscribe((res: any) => {
          if (res) {
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: res.response || 'Attendance Marked' });
            this.getCustomerAttendanceByID();
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.trainingAttendanceDialog = false;
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error.error });
          });
      }
    });
  }

  hotkeys($event) {
    var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
    var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
    var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;

    if ($event.keyCode == 39 || $event.keyCode == 37) {
      if (confirmationBoxButtonExistLength > 0) {
        if (document.activeElement.tagName === "BODY") {
          confirmationBoxButtonExist[0].focus();
        }
        else {
          if (document.activeElement === confirmationBoxButtonExist[0]) {
            confirmationBoxButtonExist[1].focus();
          }
          else if (document.activeElement === confirmationBoxButtonExist[1]) {
            confirmationBoxButtonExist[0].focus();
          }
          else {
            confirmationBoxButtonExist[0].focus();
          }
        }
      }
    }
    else if ($event.keyCode == 13 && confirmationBoxButtonExistLength <= 0) {
      this.markAttendance();
    }
  }
}
